import { NAV_MENU_TOGGLE } from 'constants/index';

export default bool => ({
  type: NAV_MENU_TOGGLE,
  isOpen: bool
});
